import type { OrderStatus } from "../types/api";

// Define active statuses (all statuses except completed/refunded/canceled)
export const ACTIVE_STATUSES: OrderStatus[] = [
  "pending",
  "pending_payment",
  "paid",
  "processing",
  "refund_requested",
];

// Page size constant for pagination
export const PAGE_SIZE = 10;

// Status options with display labels
export const STATUS_OPTIONS: { value: OrderStatus; label: string }[] = [
  { value: "pending", label: "Pending" },
  { value: "pending_payment", label: "Pending Payment" },
  { value: "paid", label: "Paid" },
  { value: "processing", label: "Processing" },
  { value: "fulfilled", label: "Fulfilled" },
  { value: "refund_requested", label: "Refund Requested" },
  { value: "refunded", label: "Refunded" },
  { value: "canceled", label: "Canceled" },
];

// Define region order from Figma design
export const REGION_ORDER = [
  "Toronto",
  "York",
  "Brampton",
  "Mississauga",
  "Cambridge",
  "Milton",
  "Other",
];

/**
 * Helper function to assign regions to campuses
 */
export const getRegionForCampus = (campusKey: string): string => {
  const regionMap: Record<string, string> = {
    avenue: "Toronto",
    beaches: "Toronto",
    bedford: "Toronto",
    college: "Toronto",
    aurora: "York",
    bradford: "York",
    elgin: "York",
    maple: "York",
    churchill: "Brampton",
    homestead: "Brampton",
    queen: "Brampton",
    wanless: "Brampton",
    ninth: "Mississauga",
    heartland: "Mississauga",
    meadowvale: "Mississauga",
    cambridge: "Cambridge",
    miltoneast: "Milton",
  };
  return regionMap[campusKey] || "Other";
};
